import { SettlementTemplateEmailName } from 'api/endpoints/settlementEmailTemplates';
import { assertSwitchValueNotEmpty } from 'utils/debugUtils';
import './SettlementEmailHeaderDescription.css';

interface Props {
  name: SettlementTemplateEmailName;
}

export const SettlementEmailHeaderDescription = (props: Props) => {
  return (
    <div className="settlement-email-header-description">
      <HeaderDescriptionContent name={props.name} />
    </div>
  );
};

const HeaderDescriptionContent = (props: { name: SettlementTemplateEmailName }) => {
  switch (props.name) {
    case 'AwaitingClientReview':
      return (
        <>
          This email is automatically sent to the <strong>"Client"</strong> when an
          admin changes the settlement status from{' '}
          <strong>"Settlement Pending" to "Awaiting Client Review"</strong>. This
          indicates that a Settlement Agreement has already been generated based on
          the data in the Settlements Platform.
        </>
      );
    case 'AwaitingCounterpartyReview':
      return (
        <>
          This email is automatically sent to the <strong>"Counterparty"</strong>{' '}
          when an admin changes the settlement status from{' '}
          <strong>"Awaiting Client Review" to "Awaiting Counterparty Review"</strong>
          . This action confirms that the <strong>"Client"</strong> has approved the
          Settlement Agreement and that it is ready to be sent to the Counterparty.
        </>
      );
    case 'AwaitingCounterpartyReviewReminder':
      return (
        <>
          This email is automatically sent to the <strong>"Counterparty"</strong>{' '}
          five days after the Settlement Agreement was initially sent, reminding them
          that they have <strong> five days remaining to accept the offer</strong>{' '}
          and electronically sign the agreement. The same reminder will be sent{' '}
          <strong>again two days before the offer's expiration</strong> to ensure the{' '}
          <strong>"Counterparty"</strong> is aware of the deadline.
        </>
      );
    case 'DeclinedByCounterparty':
      return (
        <>
          This email is automatically sent to the <strong>"Client"</strong> when the{' '}
          <strong>"Counterparty"</strong> declines the Settlement Agreement, changing
          the settlement status automatically from{' '}
          <strong>
            "Awaiting Counterparty Review" to "Declined by Counterparty"
          </strong>
          .
        </>
      );
    case 'AcceptedByCounterparty':
      return (
        <>
          This email is automatically sent to the <strong>"Client"</strong> when the{' '}
          <strong>"Counterparty"</strong> accepts and sign the Settlement Agreement,
          changing the settlement status automatically from{' '}
          <strong>
            "Awaiting Counterparty Review" to "Accepted by Counterparty"
          </strong>
          .
        </>
      );
    case 'SettlementExecuted':
      return (
        <>
          This email is automatically sent when the{' '}
          <strong>"Client" signs the Settlement Agreement</strong> following the
          Counterparty's signature. This updates the settlement status from{' '}
          <strong>"Accepted by Counterparty" to "Settlement Executed"</strong>.
        </>
      );
    case 'ClientAccountCreation':
      return (
        <>
          This email is automatically triggered and sent to the{' '}
          <strong>"Client"</strong> upon account creation. It should include details
          about their{' '}
          <strong>credentials and a link to access the Settlements Platform</strong>.
        </>
      );
  }

  //!!! if you see error here - some case is missed in the Switch statement!!!
  assertSwitchValueNotEmpty(props.name);
};
